import React, { useState } from 'react'
import { withStyles, Checkbox, FormControlLabel } from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import SaveIcon from '@material-ui/icons/Save'
import DeleteIcon from '@material-ui/icons/Delete'
import SaveDialogBase from './SaveDialogBase';

const style = theme => ({
	root: {
	},
	icon: {
		fontSize: theme.components.icon.fontSize,
	},
	padding: {
		padding: `${theme.spacing(1)}px 0`
	}
})

function SaveDialog({
	classes,
	onClose,
	showDelete = false
}) {

	const [isChecked, setIsChecked] = useState(false)
	const handleChange = (value) => {
		setIsChecked(value)
		localStorage.setItem('show_save_popup', value);
	}

	return (
		<SaveDialogBase
			onClose={onClose}
			title={showDelete ? Tr('deleted') : Tr('saved')}
			Icon={showDelete ? DeleteIcon : SaveIcon}
		>
			<FormControlLabel
				control={<Checkbox color="primary" onChange={() => handleChange(!isChecked)} />}
				label={Tr("dont_show")}
			/>
		</SaveDialogBase>
	)
}

SaveDialog.propTypes = {
	classes: PropTypes.any,
	onClose: PropTypes.func,
}

SaveDialog.defaultProps = {
}

export default withStyles(style)(SaveDialog);